module.exports = __webpack_public_path__ + "static/media/skitour.fd9ae143.png";